<template>
  <div>
    <b-overlay
      variant="white"
      :show="submitting"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <b-card no-body>
        <b-card-body>
          <b-overlay :show="loading" rounded="md" variant="transparent">
            <validation-observer ref="detailProductValidate">
              <b-form ref="detailProductFormElement">
                <b-row>
                  <b-col sm="12">
                    <b-form-group label-for="description" :label="t('Product Name')">
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Product Name')"
                        rules="required"
                      >
                        <b-form-input
                          id="description"
                          v-model="values.description"
                          name="description"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="t('Product Name')"
                          :tabindex="6"
                          autocomplete="off"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col sm="12">
                    <b-form-group label-for="origin" :label="t('Origin')">
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Origin')"
                        rules="required"
                      >
                        <v-select
                          id="origin"
                          v-model="values.origin"
                          :options="countries"
                          :placeholder="t('Make a Choice')"
                          label="text"
                          :tabindex="3"
                        >
                          <span slot="no-options">{{ t('No records found') }}</span>
                        </v-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col sm="12">
                    <b-form-group label-for="currency_code" :label="t('Currency Code')">
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Currency Code')"
                        rules="required"
                      >
                        <v-select
                          id="currency_code"
                          v-model="values.currency_code"
                          :options="currencies"
                          :placeholder="t('Make a Choice')"
                          label="text"
                          :tabindex="3"
                        >
                          <span slot="no-options">{{ t('No records found') }}</span>
                        </v-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col sm="12">
                    <b-form-group label-for="gtip" :label="t('Gtip Code')">
                      <validation-provider
                        #default="{ errors }"
                        :name="t('Gtip Code')"
                        rules="required"
                      >
                        <select-box
                          name="gtip"
                          url="api/v1/gtip/search"
                          :min="4"
                          @setValue="setGtipValue"
                        />

                        <div v-if="defaultGtip" class="mt-1">
                          <b>{{ t('Selected Gtip Code') }}:</b> {{ defaultGtip.text }}
                        </div>

                        <input id="gtip" v-model="values.gtip" name="gtip" type="hidden" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col sm="12" md="4">
                    <b-form-group
                      label-for="merchant_product_id"
                      :label="t('Merchant Product ID (M-PID / SKU)')"
                    >
                      <b-form-input
                        id="merchant_product_id"
                        v-model="values.merchant_product_id"
                        name="merchant_product_id"
                        maxlength="100"
                        :placeholder="t('e.g. SKU-TSHIRT-001')"
                        autocomplete="off"
                      />
                      <small class="text-muted">
                        {{ t('Seller product code/SKU in store (Recommended for EU)') }}
                      </small>
                    </b-form-group>
                  </b-col>

                  <b-col sm="12" md="4">
                    <b-form-group
                      label-for="manufacturer_product_id"
                      :label="t('Manufacturer Product ID (NS-PID / MPN)')"
                    >
                      <b-form-input
                        id="manufacturer_product_id"
                        v-model="values.manufacturer_product_id"
                        name="manufacturer_product_id"
                        maxlength="100"
                        :placeholder="t('e.g. MFR-TS-RED-M')"
                        autocomplete="off"
                      />
                      <small class="text-muted">
                        {{ t('Manufacturer part/model number (Recommended for EU)') }}
                      </small>
                    </b-form-group>
                  </b-col>

                  <b-col sm="12" md="4">
                    <b-form-group
                      label-for="standard_product_id"
                      :label="t('Standard Product ID (S-PID / GTIN / EAN)')"
                    >
                      <b-form-input
                        id="standard_product_id"
                        v-model="values.standard_product_id"
                        name="standard_product_id"
                        maxlength="100"
                        :placeholder="t('e.g. 8690000000012')"
                        autocomplete="off"
                      />
                      <small class="text-muted">
                        {{
                          t('Standard barcode of the product if available (GTIN, EAN, UPC, ISBN)')
                        }}
                      </small>
                    </b-form-group>
                  </b-col>

                  <b-col sm="12">
                    <b-button
                      variant="primary"
                      type="button"
                      block
                      class="mt-lg-2"
                      :disabled="submitting"
                      @click="submit"
                    >
                      <feather-icon icon="CheckIcon" size="15" />

                      {{ submitting ? t('Please Wait') : type === 'new' ? t('Add') : t('Edit') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-overlay>
        </b-card-body>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
import vSelect from 'vue-select';
import {
  BButton,
  BCard,
  BCardBody,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BRow
} from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { mapGetters } from 'vuex';
import { helper } from '@core/mixins/helper.js';
import SelectBox from '@/components/SelectBox.vue';

export default {
  components: {
    BButton,
    BCard,
    BCardBody,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BRow,
    vSelect,

    ValidationObserver,
    ValidationProvider,
    SelectBox
  },
  mixins: [helper],
  computed: {
    ...mapGetters({
      countries: 'app/countries',
      currencies: 'app/currencies'
    })
  },
  props: {
    type: {
      type: String,
      default: 'new'
    },
    submitting: {
      type: Boolean,
      default: false
    },
    defaultGtip: {
      type: Object,
      default: null
    },
    values: {
      type: Object,
      default() {
        return {
          description: '',
          gtip: '',
          origin: '',
          currency_code: '',
          merchant_product_id: '',
          manufacturer_product_id: '',
          standard_product_id: ''
        };
      }
    }
  },
  data() {
    return {
      loading: false
    };
  },
  async created() {
    await this.$store.dispatch('app/getCountries');
    await this.$store.dispatch('app/getCurrencies');
  },
  methods: {
    setGtipValue(data) {
      this.values.gtip = data.id;

      this.$emit('defaultGtip', null);
    },
    submit() {
      this.$refs.detailProductValidate.validate().then(success => {
        if (success) {
          this.$emit('submit', {
            ...this.values
          });
        }
      });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
